import * as React from "react";
import type { SVGProps } from "react";
const DotDuotoneIcon = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="1em" height="1em" fill="none" style={{
  userSelect: "none",
  flexShrink: 0
}} {...props}><path fill="#F43F48" d="M19 12a7 7 0 1 1-14 0 7 7 0 0 1 14 0" /></svg>;
export default DotDuotoneIcon;